import useNotifier from "@saleor/hooks/useNotifier";
import { commonMessages } from "@saleor/intl";
import React from "react";
import { useIntl } from "react-intl";

import ErpStatusNotePage from "../components/erpStatusNotePage";
import {
  useOrderErpStatusCreateDefaultMutation,
  useOrderErpStatusUpdateMutation
} from "../mutations";
import { useOrderErpStatusNoteQuery } from "../queries";

interface ErpStatusNote {
  params: string;
}
const ErpStatusNote: React.FC<ErpStatusNote> = ({ params }) => {
  // eslint-disable-next-line no-console
  console.log(params);
  const intl = useIntl();
  const notify = useNotifier();
  const [updateErpStatusNote] = useOrderErpStatusUpdateMutation({
    onCompleted: data => {
      if (data.orderErpStatusUpdate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage(commonMessages.savedChanges)
        });
      }
    }
  });
  const handleSubmit = (status: string, note: string) => {
    updateErpStatusNote({
      variables: {
        status,
        note
      }
    });
  };
  const [createDefaultErpStatus] = useOrderErpStatusCreateDefaultMutation({
    onCompleted: data => {
      if (data.orderErpStatusCreateDefault.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage(commonMessages.savedChanges)
        });
        refetch();
      }
    }
  });
  const { data, loading, refetch } = useOrderErpStatusNoteQuery({});
  return (
    <ErpStatusNotePage
      erpStatusNotes={data?.orderErpStatusNote}
      createDefault={createDefaultErpStatus}
      updateNote={handleSubmit}
      disabled={loading}
    />
  );
};

export default ErpStatusNote;
